import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Students enrolled in a batch, each with purchase_id + name + course.
const GetBatchStudents = async ({ payload }) => {
  const formData = new FormData();
  formData.append("session", payload.session);
  if (payload.batch_id) formData.append("batch_id", payload.batch_id);
  if (payload.course_url) formData.append("course_url", payload.course_url);

  const res = await axios.post(ENDPOINT + "admin-get-batch-students.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetBatchStudents;
